export default class ImageAdapter {
  name = "AbstractImageAdapter";

  /**
   * @param {string} src
   * @returns {boolean}
   **/
  supportSrc(src) {
    throw new Error("supportSrc method not implemented");
  }

  /**
   * @type {import("theme/components/atoms/Image/makeImageSrc").makeImageSrc}
   */
  makeImageSrc(src, format, size, bg, extension, cover, baseUrl, focalPoint) {
    throw new Error("makeImageSrc method not implemented");
  }

  /**
   * @param {boolean} transparent
   * @return {string[] | string | null}
   */
  getSupportedExtensions(transparent) {
    if (transparent) {
      return ["webp", "png"];
    }

    return ["webp", "jpeg"];
  }
  /**
   * @returns {string}
   */
  getDefaultExtension() {
    return "png";
  }
}
